/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable object-curly-newline */
import React, { useContext, useEffect, useState } from 'react';
import { sendRequest } from '../../../api/shootAPI';
import { UserContext } from '../../../contexts/User';
import API from '../../../api/endpoints';
import { STYLED_SELECT_CLASS, STYLED_SELECT_STYLE } from '../../../utils/styledSelect';
import COUNTRIES from '../../../constants/countries';

const INPUT = 'w-full h-10 px-3 border border-rule rounded-[8px] text-sm text-ink-900 placeholder:text-ink-500 focus:outline-none focus:border-brand-500';
const BTN_GHOST = 'inline-flex items-center justify-center box-border h-10 px-4 border border-rule rounded-[8px] text-sm font-medium text-ink-900 bg-white hover:bg-gray-50 transition';
const BTN_GREEN = 'inline-flex items-center justify-center box-border h-10 px-4 bg-[#53A551] text-white rounded-[8px] text-sm font-semibold hover:bg-[#458a44] transition';

function Field({ label, name, value, onChange, placeholder }) {
  return (
    <div>
      <span className="block text-sm font-medium text-ink-900 mb-1.5">{label}</span>
      <input name={name} value={value || ''} onChange={onChange} placeholder={placeholder} className={INPUT} style={{ borderStyle: 'solid', boxSizing: 'border-box', height: 40 }} />
    </div>
  );
}

function ReadRow({ label, value }) {
  return (
    <div>
      <span className="block text-[11px] font-semibold uppercase tracking-wider text-ink-500 mb-1" style={{ letterSpacing: '0.05em' }}>{label}</span>
      <span className="block text-sm text-ink-900">{value || '—'}</span>
    </div>
  );
}

function Address() {
  const { activeWorkspace } = useContext(UserContext);
  const [formData, setFormData] = useState({
    id: null, country: '', companyName: '', streetAddress: '', suiteUnit: '', city: '', state: '', zip: '', additionalNote: '',
  });
  const [isEditing, setIsEditing] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const handleForm = (name, value) => setFormData((prev) => ({ ...prev, [name]: value }));
  const onChange = (e) => handleForm(e.target.name, e.target.value);

  const fetchBillingAddress = async () => {
    const response = await sendRequest({ method: 'get', url: API.WORKSPACE.billingAddress(activeWorkspace.id) });
    if (response.success && response.data) {
      setFormData(response.data);
      setIsUpdate(true);
    }
  };

  const handleSubmit = async () => {
    const method = formData.id ? 'put' : 'post';
    const response = await sendRequest({ method, url: API.WORKSPACE.billingAddress(activeWorkspace.id), data: formData });
    if (response.success) {
      setFormData(response.data);
      setIsUpdate(true);
      setIsEditing(false);
    }
  };

  useEffect(() => {
    fetchBillingAddress();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fullAddress = [formData.streetAddress, formData.suiteUnit, formData.city, formData.state, formData.zip].filter(Boolean).join(', ');

  return (
    <div className="p-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between mb-5">
        <div className="min-w-0">
          <h4 className="text-base font-semibold text-ink-900 mb-0.5">Billing Address &amp; Details</h4>
          <p className="text-sm text-ink-500">This information will appear on all invoices associated with your account</p>
        </div>
        {isEditing ? (
          <div className="flex items-center gap-2 flex-shrink-0">
            <button type="button" className={BTN_GHOST} style={{ borderStyle: 'solid' }} onClick={() => setIsEditing(false)}>Cancel</button>
            <button type="button" className={BTN_GREEN} onClick={handleSubmit}>Save Changes</button>
          </div>
        ) : (
          <button type="button" className={BTN_GREEN} onClick={() => setIsEditing(true)}>
            {isUpdate ? 'Edit Details' : 'Add Details'}
          </button>
        )}
      </div>

      {isEditing ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4" style={{ maxWidth: 820 }}>
          <div>
            <span className="block text-sm font-medium text-ink-900 mb-1.5">Country</span>
            <select name="country" value={formData.country || ''} onChange={onChange} className={`${STYLED_SELECT_CLASS} w-full`} style={STYLED_SELECT_STYLE}>
              <option value="">Select country</option>
              {COUNTRIES.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <Field label="Company Name" name="companyName" value={formData.companyName} onChange={onChange} placeholder="Company name" />
          <Field label="Street Address" name="streetAddress" value={formData.streetAddress} onChange={onChange} placeholder="Street address" />
          <Field label="Suite / Unit" name="suiteUnit" value={formData.suiteUnit} onChange={onChange} placeholder="Suite / unit" />
          <Field label="City" name="city" value={formData.city} onChange={onChange} placeholder="City" />
          <Field label="State" name="state" value={formData.state} onChange={onChange} placeholder="State" />
          <Field label="Zip" name="zip" value={formData.zip} onChange={onChange} placeholder="Zip" />
          <div className="md:col-span-2">
            <span className="block text-sm font-medium text-ink-900 mb-1.5">Additional Notes</span>
            <textarea
              name="additionalNote"
              value={formData.additionalNote || ''}
              onChange={onChange}
              placeholder="Any additional information you'd like on your billing statement"
              className="w-full px-3 py-2 border border-rule rounded-[8px] text-sm text-ink-900 placeholder:text-ink-500 focus:outline-none focus:border-brand-500"
              style={{ borderStyle: 'solid', minHeight: 96, resize: 'vertical', boxSizing: 'border-box' }}
            />
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" style={{ maxWidth: 720 }}>
          <ReadRow label="Country" value={formData.country} />
          <ReadRow label="Company Name" value={formData.companyName} />
          <ReadRow label="Address" value={fullAddress} />
          <ReadRow label="Additional Notes" value={formData.additionalNote} />
        </div>
      )}
    </div>
  );
}

export default Address;
